import { useContext } from 'react'
import { SidePanelPrivateContext } from './SidePanelProvider'
import type { SidePanelPrivateContextValue } from './types'

/**
 * INTERNAL HOOK - Only for use in SidePanel components
 *
 * This hook provides access to setIsSidePanelFocused which should only
 * be modified by the SidePanel component itself. All other components
 * should use useSidePanel() for read-only access to isSidePanelFocused.
 *
 * @internal
 * @private
 */
export function useSidePanelPrivate(): SidePanelPrivateContextValue {
  return useContext(SidePanelPrivateContext)
}
